import { Select } from "antd";
import { type FC, useState } from "react";

import type { DynamicPropertyToGroupEntity } from "src/app/features/DynamicPropertyGroup/types/DynamicPropertyToGroupEntity";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { createQueryParams, useGetTableDataQuery } from "../../../index";
import { SelectInput } from "../../../Select/SelectInput";
import type { FetchDataQuery } from "../../../Table/types/types";
import type { PropertyTableSelector } from "../../types/types";

export const DynamicPropertySelector: FC<PropertyTableSelector> = ({ onSelected }) => {
    const [selectedValue, setSelectedValue] = useState<string | undefined>();
    const resourceFetchPath = `/${ResourceName.DYNAMIC_PROPERTIES}`;

    const queryConfig = {
        pageSize: 1000,
        currentPage: 1,
        filters: { status: "ACTIVE" },
        sorter: { field: "name", order: "ascend" as const },
    };
    const query = createQueryParams(queryConfig);

    const fetchDataQuery = {
        query,
        resourceFetchPath,
        dataMapperKey: "dynamicPropertyToGroupTableData",
    } as FetchDataQuery;

    const { data, isLoading } = useGetTableDataQuery(fetchDataQuery);

    const options: DynamicPropertyToGroupEntity[] = data?.list || [];

    const onValueChange = (selectedOption: string) => {
        setSelectedValue(selectedOption);
        const selected = options.find((opt) => String(opt.id) === String(selectedOption));

        onSelected?.({
            ...selected,
            dynamicPropertyId: selected?.id,
            id: undefined,
        });
    };

    return (
        <SelectInput isLoading={isLoading} disabled={false} value={selectedValue} onChange={onValueChange}>
            {options.map((option) => (
                <Select.Option key={option.id} value={option.id}>
                    {option.name}
                </Select.Option>
            ))}
        </SelectInput>
    );
};
